import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {compareValidator} from '../confirmPasswordValidator';
import {AuthService} from '../auth.service';
import {AlertService} from '../alert.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.sass']
})
export class RegistrationComponent implements OnInit {

  form: FormGroup
  authError: any
  constructor(private auth: AuthService, private alert: AlertService) { }

  ngOnInit() {
    this.form = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      chessComName: new FormControl(null),
      coin: new FormControl(0),
      password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
      confirmpassword: new FormControl(null, [Validators.required, compareValidator('password')])
    });
    this.auth.eventAuthError$.subscribe(data => {
      this.authError = data;
    });
  }

  createUser(form) {
    if (this.form.invalid) {
      return;
    }
    this.auth.createUser(form.value);
    this.alert.success('Вы успешно зарегистрировались');
  }
}
